import React from 'react';

import ModalFilter from 'components/ModalFilter';
import { checkIfIsAddressCompany } from 'services/api/locals';
import { setUserTaskAPI } from 'services/api/task';
import { createUserLinkTask, getUserByEmail } from 'services/api/users';
import { LinkUserTask as LinkUser } from 'triider-components';

function LinkUserTask({
  isOpen, setIsOpen, task, _growl, _growlTypes, _setUserSuccess,
}) {
  return (
    <ModalFilter padding="30px 20px 40px 40px" isOpen={isOpen} textTransform="none" title={task.service_name} toggle={() => setIsOpen(!isOpen)}>
      <LinkUser
        task={{ ...task, local_address_name: task.local_address }}
        checkIfIsAddressCompany={checkIfIsAddressCompany}
        createUser={createUserLinkTask}
        setIsOpen={setIsOpen}
        setUserTaskAPI={setUserTaskAPI}
        getUserByEmail={getUserByEmail}
        _growl={_growl}
        _growlTypes={_growlTypes}
        _setUserSuccess={_setUserSuccess}
        withMessage
      />
    </ModalFilter>
  );
}

export default LinkUserTask;
